import React from 'react'
import { Link } from "react-router-dom";
import "../../../styles/servicios/menu_servicios.css"
import Buscador from '../../Reutilizables/buscador/Buscador'

function Menu_servicios() {

  return (
    <div className="navbar navbar-servi">

        <div className='first-link'>
          <Link to="/" className='nav-link'>Inicio</Link>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Impuestos municipales <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="/servicios-industria-comercio" className='nav-link'>Industria y comercio</Link>
            <Link to="/servicios-complementario-avisos" className='nav-link'>Complementario de avisos</Link>
            <Link to="/servicios-publicidad-exterior-visual" className='nav-link'>Publicidad exterior</Link>
            <Link to="/servicios-predial-unificado" className='nav-link'>Predial unificado</Link>
            <Link to="/servicios-sobretasa-ambiental" className='nav-link'>Sobretasa ambiental</Link>
            <Link to="/servicios-sobretasa-corporaciones-regionales" className='nav-link'>Sobretasa corporaciones regionales</Link>
            <Link to="/servicios-sobretasa-gasolina" className='nav-link'>Sobretasa gasolina</Link>
            <Link to="/servicios-sobre-vehiculos" className='nav-link'>Sobre vehículos</Link>
            <Link to="/servicios-venta-sistema-clubes" className='nav-link'>Clubes</Link>
            <Link to="/servicios-espectaculo-publico-municipal" className='nav-link'>Espectáculo público municipal</Link>
            <Link to="/servicios-espectaculos-publicos-nacional" className='nav-link'>Espectáculo público nacional</Link>
            <Link to="/servicios-transporte-oleo-gaso" className='nav-link'>Oleoductos y gasoductos</Link>
            <Link to="/servicios-deguello-ganado" className='nav-link'>Degüello de ganado</Link>
            <Link to="/servicios-contribucion-contratos" className='nav-link'>Contratos de obra pública</Link>
            <Link to="/servicios-alumbrado-publico" className='nav-link'>Alumbrado público</Link>
            <Link to="/servicios-delineacion-urbana" className='nav-link'>Delineación urbana</Link>
            <Link to="/servicios-explotacion-mineral-nacional" className='nav-link'>Explotación mineral</Link>
            <Link to="/servicios-financiar-actividad-bomberil" className='nav-link'>Actividad bomberil</Link>
            <Link to="/servicios-estampillas" className='nav-link'>Estampillas</Link>
            <Link to="/servicios-tasas" className='nav-link'>Tasas <i className="fa fa-caret-down"></i></Link>
            <Link to="/servicios-contribuciones" className='nav-link'>Contribuciones <i className="fa fa-caret-down"></i></Link>
          </div>
        </div> 

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Fiscalización <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización</Link>
            <Link to="" className='nav-link'>Info Fiscalización <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Fiscalización <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Procedimiento tributario <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario</Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Procedimiento tributario <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Proceso sancionatorio <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio</Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Proceso sancionatorio <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Normatividad <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad</Link>
            <Link to="" className='nav-link'>Info Normatividad <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Normatividad <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Cobro coactivo <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo</Link>
            <Link to="" className='nav-link'>Info Cobro coactivo <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Cobro coactivo <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Minutas y modelos <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos</Link>
            <Link to="" className='nav-link'>Info Minutas y modelos <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Minutas y modelos <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className="subnav subnav-servi">
          <button className="subnavbtn">Estatuto tributario <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario</Link>
            <Link to="" className='nav-link'>Info Estatuto tributario <i className="fa fa-caret-down"></i></Link>
            <Link to="" className='nav-link'>Info Estatuto tributario <i className="fa fa-caret-down"></i></Link>
          </div>
        </div>

        <div className='search-servi'>
          <Buscador />
        </div>
      </div>
  )
}

export default Menu_servicios